import { useTranslation } from 'libs/translations';

import { FitlineClubMemberBadge } from './FitlineClubMemberBadge';

export function FitlineClubMemberBadgeDescription() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row items-center justify-center flex-wrap gap-xs">
      <FitlineClubMemberBadge hideDetails />
      <p>{t('FitLine Club member')}</p>
    </div>
  );
  return null;
}
